import type { AxiosError } from "axios";

export interface Problem {
  title: string;
  message: string;
  signOut: boolean;
}

// asterisk has no accounts, so the API refuses only these three (spec 2026-10-15 §4.2; not_staff: authz gap plan 0a).
const ACCOUNT_CODES = ["domain_not_allowed", "email_required", "not_staff"] as const;

export const PROBLEMS: Record<string, Problem> = {
  unreachable: {
    title: "Telephony API unreachable",
    message: "Could not reach the Telephony Control Plane API. Please try again.",
    signOut: false,
  },
  not_configured: {
    title: "Sign-in not configured",
    message: "This build has no sign-in settings (VITE_COGNITO_AUTHORITY, VITE_COGNITO_DOMAIN, VITE_COGNITO_CLIENT_ID).",
    signOut: false,
  },
  failed: { title: "Sign-in failed", message: "Sign-in did not complete. Please try again.", signOut: false },
  domain_not_allowed: {
    title: "Account unavailable",
    message: "Your email domain is not allowed to use the Telephony Control Plane.",
    signOut: true,
  },
  email_required: {
    title: "Account unavailable",
    message: "Your Voicing account has no verified email.",
    signOut: true,
  },
  not_staff: {
    title: "Account unavailable",
    message: "Your account is not on the Telephony Control Plane staff list. Ask a platform admin to add you.",
    signOut: true,
  },
};

export function unavailableCode(error: unknown): (typeof ACCOUNT_CODES)[number] | null {
  const e = error as AxiosError<{ detail?: unknown }> | null;
  if (e?.response?.status !== 403) return null;
  const code = e.response.data?.detail;
  return ACCOUNT_CODES.find((c) => c === code) ?? null;
}
